import type { App } from 'vue'
/**
 * Register layouts in the app instance
 */
export function registerLayouts(app: App) {
  const layouts = import.meta.glob('../layouts/*.vue', { eager: true })

  Object.entries(layouts).forEach(([, layout]: any) => {
    app.component(layout?.default?.name, layout?.default)
  })
}
